import { useContext } from 'react';
import { LanguageContext } from '../App';

export type Language = 'en' | 'hi';

export const useLanguage = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'hi' : 'en');
  };

  return { language, toggleLanguage };
};    
